import {Component, OnInit} from '@angular/core';
import {TasksService} from '../../services/tasks.service';
import {ServService} from '../../services/serv.service';
import {MagasinService} from '../../services/magasin.service';
import {BikeService2} from '../../services/bike2.service';
import {OrderService} from '../../services/order.service';

@Component({
    selector: 'my-tasks',
    template: require('./tasks.component.html'),
    styles: [require('./tasks.component.scss')]
})

export class TasksComponent implements OnInit {

    filter = {
        cas: 0,
        magasin: '',
        type: 1,
        quantity: 200,
        end: false,
        status: 'inProgress'
    };
    today;

    constructor(public orderService: OrderService, public magasinService: MagasinService,
                public tasksService: TasksService, public servService: ServService, public bikeService2: BikeService2) {
        this.filter.magasin = this.magasinService.current;
        this.today = new Date().getTime();
    }

    openService(service) {
        this.servService.current = service;
        this.bikeService2.getAll(service.client.id);
    }

    openOrder(order) {
        this.orderService.load(order);
    }

    ngOnInit(): void {
        this.tasksService.getAll(this.filter);
    }

    diffDate(date1: Date, date2: Date = null): number {
        if (!date2) {
            date2 = new Date();
        }
        let timeDiff = Math.abs(date2.getTime() - date1.getTime());
        let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

        return diffDays - 1;
    }

    refresh() {
        this.tasksService.getAll(this.filter);
    }

    calculeWidthBar(day: number, maxDay: number, maxWidth: number) {
        let width = 15;
        width += maxWidth / maxDay * day;
        if (width > maxWidth) {
            width = 100;
        }
        return width + '%';
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/pages/tasks/tasks.component.ts